import { render, staticRenderFns } from "./ai-info-of-member.html?vue&type=template&id=49b08423&scoped=true&external"
import script from "./ai-info-of-member.js?vue&type=script&lang=js&external"
export * from "./ai-info-of-member.js?vue&type=script&lang=js&external"
import style0 from "./ai-info-of-member.scss?vue&type=style&index=0&id=49b08423&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b08423",
  null
  
)

export default component.exports